export const fetchOk = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const response = await fetch(...args)
    if (!response.ok) {
        const input = args[0]
        const url = typeof input === "string" ? input : input instanceof URL ? input.href : input.url
        throw new Error(`fetchOk: request failed with status ${response.status} ${response.statusText} for ${url}`)
    }
    return response
}
